/*
 *
 * Title: firebase configuration
 * Description: firebase configuration and auth providers exported
 * Author: Shah Arafat
 *
 */

import {initializeApp} from 'firebase/app';
import {
    FacebookAuthProvider,
    getAuth,
    GoogleAuthProvider,
    OAuthProvider,
} from "firebase/auth";

let firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// firebase auth
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();

export const facebookProvider = new FacebookAuthProvider();

export const appleProvider = new OAuthProvider('apple.com')
